import { getDefaultConfig } from '@guiker/config'

export const config = {
  ...getDefaultConfig('recommended-listing'),
  recommendedListingsEmailFrequency: {
    days: 1,
  } as const,
}
